import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer className="bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 text-gray-300 py-20 border-t border-gray-700">
      <div className="max-w-7xl mx-auto px-6">

        {/* Main Footer Grid */}
        <div className="grid md:grid-cols-4 gap-12 mb-16">

          {/* Brand */}
          <div className="md:col-span-1">
            <h3 className="text-white text-3xl font-semibold mb-4 logo-great">
              <span className="logo-my">My</span>
              <span className="logo-trip">Trip</span>
            </h3>
            <p className="text-sm text-gray-400 mb-4">
              Discover premium stays and dining experiences near you with intelligent geosearch.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="hover:text-brand-orange transition">Home</Link></li>
              <li><Link to="/hotels" className="hover:text-brand-orange transition">Hotels</Link></li>
              <li><Link to="/restaurants" className="hover:text-brand-orange transition">Restaurants</Link></li>
              <li><Link to="/about" className="hover:text-brand-orange transition">About Us</Link></li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="text-white font-semibold mb-4">Support</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/contact" className="hover:text-brand-orange transition">Contact Us</Link></li>
              <li><Link to="/faq" className="hover:text-brand-orange transition">FAQ</Link></li>
              <li><Link to="/privacy-policy" className="hover:text-brand-orange transition">Privacy Policy</Link></li>
              <li><Link to="/terms-of-service" className="hover:text-brand-orange transition">Terms of Service</Link></li>
            </ul>
          </div>

          {/* Connect */}
          <div>
            <h4 className="text-white font-semibold mb-4">Connect</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="#" className="hover:text-brand-orange transition">Facebook</a></li>
              <li><a href="#" className="hover:text-brand-orange transition">Instagram</a></li>
              <li><a href="#" className="hover:text-brand-orange transition">Twitter</a></li>
              <li><a href="#" className="hover:text-brand-orange transition">LinkedIn</a></li>
            </ul>
          </div>

        </div>

        {/* Divider */}
        <div className="border-t border-gray-700 pt-8">

          {/* Bottom Footer */}
          <div className="flex flex-col md:flex-row justify-between items-center text-sm text-gray-400">
            <p>© 2026 MyTrip4U. All rights reserved.</p>
            <p className="mt-4 md:mt-0">Made with ❤️ for travelers</p>
          </div>

        </div>

      </div>
    </footer>
  );
}

export default Footer;
